import * as React from "react"
import { Lottie } from "@digits-shared/components/UI/Lottie/Lottie"
import { type ButtonSize } from "@digits-shared/DesignSystem/Button"
import styled from "styled-components"

const sizes: Record<ButtonSize, number> = {
  small: 11,
  medium: 14,
  default: 16,
}

const Center = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

// extra specificity is needed to prevent button level overrides
const LoaderAnim = styled(Lottie)<{ size: ButtonSize }>`
  height: ${({ size }) => sizes[size]}px;
  svg {
    position: unset !important;
    margin-left: 0 !important;
  }
`

/**
 * Provides a Lottie-based loading animation
 */
export const Loader: React.FC<{ className?: string; size: ButtonSize }> = ({ className, size }) => (
  <LoaderAnim
    className={className}
    aria-label="loading"
    animationData={require("shared/static/lottie/bubble-loader.json")}
    size={size}
  />
)

/**
 * Centers a loading animation within the parent container
 */
export const CenteredLoader: React.FC<{ className?: string; size: ButtonSize }> = ({
  className,
  size,
}) => (
  <Center className={className}>
    <Loader size={size} />
  </Center>
)
